// Import Flickity
import Flickity from 'flickity';

const LogoCarousel = () => {
  const flickity = new Flickity('.js-logo-carousel', {
      cellAlign: 'left',
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });

  // Previous
  const previousButton = document.querySelector(
    '.logo-carousel .carousel-controls .js-carousel-button-previous'
  );

  previousButton.addEventListener('click', function() {
    flickity.previous();
  });

  // Next
  const nextButton = document.querySelector(
    '.logo-carousel .carousel-controls .js-carousel-button-next'
  );
  nextButton.addEventListener('click', function() {
    flickity.next();
  });
};

export default LogoCarousel;
